<template>
  <v-dialog v-model="dialog" persistent max-width="490">
    <v-card class="px-2 py-2">
      <div class="d-flex align-center">
        <p class="text-left color-darkGray px-4 py-6" style="font-size: 18px">
          {{ text }}
        </p>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="ok"> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    text: { type: String },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    ok() {
      this.dialog = false;
      this.$emit('ok');
    },
  },
};
</script>
